import { useAuth0 } from '@auth0/auth0-react';
import {
    Box,
    Button,
    Checkbox,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TablePagination,
    TableRow,
    CircularProgress,
    Typography,
    Input,
    TextField,
    styled,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import React, { useEffect } from 'react';
import TitleCase from '../BasicComponents/TitleCase';
import InviteUsers from './InviteUsers';
import { updateSchool } from '../../redux/SchoolSlice';

const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

export const StaffNeeds = props => {
    const dispatch = useDispatch();
    const { getAccessTokenSilently } = useAuth0();
    const [state, setState] = React.useState({
        'full-time-teachers': 0,
        'casual-teachers': 0,
    });

    function handleChange(event) {
        setState({
            ...state,
            [event.target.id]: event.target.value,
        });
    }

    useEffect(() => {
        if (
            props.school.school.Data.fullTimeTeachers !== undefined &&
            props.school.school.Data.casualTeachers !== undefined
        ) {
            setState({
                'full-time-teachers': props.school.school.Data.fullTimeTeachers,
                'casual-teachers': props.school.school.Data.casualTeachers,
            });
        }
    }, [props.fullTimeTeachers, props.casualTeachers]);

    async function handleSave() {
        console.log('Save');
        if (state['full-time-teachers'] < 0 || state['casual-teachers'] < 0) {
            return;
        } else {
            // Save to database
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            var updateList = [
                { key: 'fullTimeTeachers', value: state['full-time-teachers'] },
                { key: 'casualTeachers', value: state['casual-teachers'] },
            ];
            let dynamoData = {
                token: token,
                request: {
                    'updateList': updateList,
                },
            };
            const generalResponse = await dispatch(updateSchool(dynamoData));
        }
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Typography variant="h3" sx={{ margin: '6px 0px' }}>
                Inform others about your school staffing needs
            </Typography>
            <Typography sx={{ margin: '6px 0px' }}>
                How many full time teachers do you need?
            </Typography>
            <TextField
                sx={{ margin: '6px 0px' }}
                id="full-time-teachers"
                label="Full Time Teachers Required"
                variant="outlined"
                value={state['full-time-teachers']}
                onChange={handleChange}
            />
            <Typography sx={{ margin: '6px 0px' }}>
                How many casual / substitute teachers do you need?
            </Typography>
            <TextField
                sx={{ margin: '6px 0px' }}
                id="casual-teachers"
                label="Casual Time Teachers Required"
                variant="outlined"
                value={state['casual-teachers']}
                onChange={handleChange}
            />
            <Box>
                <BookingButton
                    variant="outlined"
                    onClick={handleSave}
                    align="left"
                    startIcon={<SaveIcon />}
                    sx={{ m: 1 }}
                >
                    Save
                </BookingButton>
            </Box>
        </Box>
    );
};

export default StaffNeeds;
